import React from "react";

const HubspotIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.66003,
  y: 1.67,
  width: 16.67,
  height: 16.67,
  rx: 2,
  fill: "url(#paint0_linear_368_357)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_357)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4508 9.73506C14.2131 9.32931 13.8739 8.99238 13.4666 8.75736C13.1556 8.57664 12.834 8.46186 12.471 8.4122V7.11213C12.647 7.03917 12.7972 6.91506 12.902 6.75585C13.0067 6.59665 13.0614 6.40967 13.0587 6.2191C13.0594 6.0904 13.0346 5.96284 12.9858 5.84376C12.937 5.72467 12.8651 5.61641 12.7743 5.52518C12.6836 5.43395 12.5757 5.36155 12.4568 5.31215C12.338 5.26276 12.2105 5.23733 12.0818 5.23733C11.8212 5.23733 11.5711 5.34066 11.3865 5.52468C11.2018 5.70871 11.0977 5.95842 11.0968 6.2191C11.0968 6.61799 11.3085 6.95827 11.6724 7.11213V8.40487C11.3709 8.44849 11.0785 8.54029 10.8062 8.67677L7.32606 6.04163C7.35048 5.94964 7.37164 5.85439 7.37164 5.75426C7.37164 5.15348 6.88483 4.66667 6.28405 4.66667C5.68326 4.66667 5.19727 5.15348 5.19727 5.75426C5.19727 6.35504 5.68408 6.84186 6.28486 6.84186C6.49001 6.84186 6.67969 6.78162 6.84331 6.68311L7.07125 6.8557L10.1932 9.1066C10.028 9.25801 9.87409 9.4306 9.75117 9.62435C9.50206 10.0192 9.34983 10.4531 9.34983 10.9269V11.0245C9.35093 11.3459 9.40881 11.6644 9.52079 11.9656C9.61522 12.2229 9.75361 12.4573 9.92538 12.669L8.88825 13.7085C8.58135 13.5946 8.237 13.6703 8.00499 13.9023C7.84706 14.0594 7.75833 14.2735 7.75914 14.4965C7.75995 14.7196 7.84706 14.9321 8.0058 15.0908C8.16455 15.2496 8.37702 15.3375 8.60007 15.3375C8.82313 15.3375 9.03723 15.2496 9.19434 15.0908C9.35146 14.9321 9.44101 14.7196 9.44019 14.4965C9.44013 14.4109 9.42695 14.3258 9.40112 14.2442L10.4724 13.1729C10.619 13.2746 10.7777 13.3601 10.9487 13.4334C11.3 13.5875 11.6795 13.6673 12.0631 13.6678H12.1364C12.5858 13.6678 13.0099 13.562 13.408 13.3463C13.8172 13.1269 14.1609 12.803 14.4044 12.4076C14.6543 12.0088 14.7911 11.5667 14.7911 11.0807V11.0563C14.7911 10.5784 14.6804 10.138 14.4492 9.73424L14.4508 9.73506ZM13.1426 11.9835C12.852 12.3067 12.5174 12.5061 12.1396 12.5061H12.068C11.8523 12.5061 11.6406 12.4467 11.4347 12.3376C11.2088 12.2202 11.0175 12.046 10.8795 11.8321C10.7297 11.6204 10.6483 11.3892 10.6483 11.1442V11.0709C10.6483 10.83 10.6947 10.6012 10.8111 10.3855C10.9356 10.1413 11.1042 9.96625 11.328 9.82054C11.5519 9.67482 11.7823 9.60481 12.0444 9.60481H12.0688C12.3049 9.60481 12.5304 9.65121 12.7421 9.75948C12.9565 9.87225 13.1386 10.0378 13.2712 10.2406C13.4025 10.4439 13.4837 10.6755 13.5081 10.9163L13.5138 11.0685C13.5138 11.3998 13.3868 11.7067 13.1336 11.9851L13.1426 11.9835Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_368_357",
  x1: 18.33,
  y1: 1.67,
  x2: 1.66003,
  y2: 18.34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD8B5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2585B"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_357"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.67,
  height: 10.67,
  fill: "white",
  transform: "translate(4.66003 4.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HubspotIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;